var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17142 14.8H13.8286C15.1143 14.8 16 13.7809 16 12.619C16 12.2571 15.9143 11.8952 15.7143 11.5524L9.87619 1.08571C9.46667 0.36191 8.74285 0 7.99999 0C7.26667 0 6.51427 0.36191 6.12381 1.08571L0.285713 11.5619C0.0857136 11.8857 0 12.2571 0 12.619C0 13.7809 0.88571 14.8 2.17142 14.8ZM8.00953 9.44761C7.40952 9.44761 7.06667 9.13333 7.03809 8.53333L6.91428 5.97144C6.87618 5.33334 7.33334 4.89524 7.99999 4.89524C8.67618 4.89524 9.1238 5.33334 9.09524 5.97144L8.96191 8.52381C8.93333 9.13333 8.59999 9.44761 8.00953 9.44761ZM8.00953 12.4286C7.29522 12.4286 6.84761 12.0476 6.84761 11.419C6.84761 10.8 7.28571 10.4286 8.00953 10.4286C8.70475 10.4286 9.15237 10.8095 9.15237 11.419C9.15237 12.0476 8.71427 12.4286 8.00953 12.4286Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.a6c54b2e74419d8a5eb2f00e328e81f2.svg";
export { ForwardRef as ReactComponent };